import { Injectable } from '@angular/core';
import { IAuthService } from '../iauth.service';

import { AuthConfig } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc';
import { OAuthService } from 'angular-oauth2-oidc';
import { UserManager, UserManagerSettings, User } from 'oidc-client';

declare var virtualDirectory;

export const oktaAuthConfig: AuthConfig = {
    issuer: '',
    tokenEndpoint: '',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '',
    scope: 'openid email',
    strictDiscoveryDocumentValidation: false,
    loginUrl: '',
    requestAccessToken: false,
    responseType: "id_token"
}

export const microsoftAuthConfig: AuthConfig = {
    issuer: 'https://graph.microsoft.com/v1.0/me',
    tokenEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '',
    scope: 'User.Read email profile',
    strictDiscoveryDocumentValidation: false,
    loginUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    requestAccessToken: true,
    responseType: "id_token"
}

export const googleAuthConfig: AuthConfig = {
    issuer: 'https://accounts.google.com',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    logoutUrl: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '',
    scope: 'openid profile email',
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    sessionChecksEnabled: true
}

export const oneLoginAuthConfig: any = {
    authority: null,
    client_id: null,
    redirect_uri: window.location.origin + '/' + virtualDirectory,
    post_logout_redirect_uri: window.location.origin + '/' + virtualDirectory,
    response_type: 'id_token token',
    scope: 'openid profile',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    silent_redirect_uri: window.location.origin + '/' + virtualDirectory
};

@Injectable({providedIn: 'root'})
export class SSOService implements IAuthService {

    private oneLoginUserManager: UserManager = null;

    private googleId: string = 'GOOGLE';
    private microsoftId: string = 'MICROSOFT';
    private oktaId: string = 'OKTA';
    private oneLoginId: string = 'ONELOGIN';
    private authConfig: AuthConfig = null;
    private provider: string = '';
    public ssoSettings: Array<any> = null;

    private providerId: string = null;

    constructor(private oauthService: OAuthService) { }

    private async configureWithNewConfigApi() {
        if (this.ssoSettings) {
            for (let i = 0; i < this.ssoSettings.length; i++) {
                if (this.ssoSettings[i]["ID"] == "GOOGLE") googleAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                if (this.ssoSettings[i]["ID"] == "MICROSOFT LIVE" || this.ssoSettings[i]["ID"] == "MICROSOFTLIVE") microsoftAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                if (this.ssoSettings[i]["ID"] == "MICROSOFT AZURE" || this.ssoSettings[i]["ID"] == "MICROSOFTAZURE") microsoftAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                if (this.ssoSettings[i]["ID"] == "OKTA") {
                    oktaAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                    oktaAuthConfig.issuer = this.ssoSettings[i]["BaseUrl"];
                    oktaAuthConfig.tokenEndpoint = oktaAuthConfig.issuer + '/oauth2/v1/token';
                    oktaAuthConfig.loginUrl = oktaAuthConfig.issuer + '/oauth2/v1/authorize';
                }
                if (this.ssoSettings[i]["ID"] == "ONELOGIN") {
                    oneLoginAuthConfig.client_id = this.ssoSettings[i]["ClientId"];
                    oneLoginAuthConfig.authority = this.ssoSettings[i]["BaseUrl"] + '/oidc/2';
                    this.oneLoginUserManager = new UserManager(oneLoginAuthConfig);
                }
            }

            let providerId = localStorage.getItem("providerName");
            this.providerId = providerId;
            if (providerId == this.googleId) this.authConfig = googleAuthConfig;
            if (providerId.indexOf(this.microsoftId) > -1) this.authConfig = microsoftAuthConfig;
            if (providerId == this.oktaId) this.authConfig = oktaAuthConfig;
            this.oauthService.configure(this.authConfig);
            this.oauthService.tokenValidationHandler = new JwksValidationHandler();
            this.oauthService.setStorage(sessionStorage);
            if (providerId == this.googleId) {
                await this.oauthService.loadDiscoveryDocumentAndTryLogin();
            }
        }
    }

    public async authenticate() {
        await this.configureWithNewConfigApi();
        if (this.providerId == this.oneLoginId) {
            this.oneLoginUserManager.signinRedirect();
        } else {
            this.oauthService.initImplicitFlow();
        }
        return null;
    }
}
